import { ComponentProps, ReactNode } from 'react';

import { v4 as uuidv4 } from 'uuid';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { cn } from '@/utils/tailwind';

import { CheckIcon } from '../../../assets/icons';

type CheckboxProps = ComponentProps<typeof CheckboxPrimitive.Root> & {
  label?: ReactNode;
};

const Checkbox = ({ className, label, id, ...props }: CheckboxProps) => {
  const autoId = uuidv4();
  const checkboxId = id ?? autoId;

  return (
    <div className="flex items-center gap-2">
      <CheckboxPrimitive.Root
        id={checkboxId}
        data-slot="checkbox"
        className={cn(
          'size-5 flex items-center justify-center cursor-pointer border border-custom-warm-grey-200 data-[state=checked]:border-custom-cyan-400 data-[state=checked]:bg-custom-cyan-400 rounded-[4px] hover:bg-custom-warm-grey-100',
          className
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          className="flex items-center justify-center"
        >
          <CheckIcon className="text-custom-warm-grey-25" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>

      {label && (
        <label
          htmlFor={checkboxId}
          className="text-body-14-regular text-custom-warm-grey-700 cursor-pointer select-none"
        >
          {label}
        </label>
      )}
    </div>
  );
};

export { Checkbox };
